import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import classnames from "classnames";

import GlobalMessenger from "apps/messenger";
import NotificationDisplay from "apps/notifications_footer/components/NotificationDisplay";
import Notification from "apps/notifications_footer/components/Notification";
import useNotifications from "apps/notifications_footer/util/useNotifications";

import "./App.scss";

const App = ({
	userid,
}) => {
	// Under certain conditions, we'll want to enable/disable auto-dismissing.
	const [shouldAutoDismissNotifications, setShouldAutoDismissNotifications] = useState(true);

	// Process notifications for showing, and handle auto-dismissing if enabled.
	const {
		notifications,

		isBoostReport,
		isBoostReportExpanded,
		isBoosting,
		toggleBoostReport,
		closeBoostReport,
	} = useNotifications({
		userid,
		shouldAutoDismissNotifications,
	});

	// Do we have any visible notifications to show?
	const hasVisibleNotifications = notifications
		.filter(({ isHidden }) => !isHidden).length > 0;

	// Hovering tempoprarily disables auto-dismissing.
	// It should also be disabled in Boost report mode.
	const onHoverStart = () => setShouldAutoDismissNotifications(false);
	const onHoverEnd = () => setShouldAutoDismissNotifications(!isBoostReport);
	useEffect(() => setShouldAutoDismissNotifications(!isBoostReport), [isBoostReport]);

	return (
		<div
			className={classnames("notifications-footer", "clearfix", {
				"notifications-footer--hasNotifications": hasVisibleNotifications,
				"notifications-footer--expanded": isBoostReportExpanded,
				"notifications-footer--collapsed": !isBoostReportExpanded,
				"notifications-footer--boost-running": isBoostReport && isBoosting,
				"notifications-footer--boost-reporting": isBoostReport && !isBoosting,
			})}
		>
			<NotificationDisplay
				showBoostReportHeader={isBoostReport}
				isBoosting={isBoosting}
				isBoostReportExpanded={isBoostReportExpanded}
				onToggleBoostReport={toggleBoostReport}
				onCloseBoostReport={closeBoostReport}
				onHoverStart={onHoverStart}
				onHoverEnd={onHoverEnd}
			>
				{notifications.map((notification) => (
					<Notification
						key={notification.id}
						isBoostActivity={isBoostReport}
						{...notification}
					/>
				))}
			</NotificationDisplay>
			<GlobalMessenger />
		</div>
	);
};

App.propTypes = {
	userid: PropTypes.string.isRequired,
};

export default App;



// WEBPACK FOOTER //
// ./src/apps/notifications_footer/components/App.jsx